<template>
  <div>
    <header-title :Title="detailItem.Name"></header-title>
    <div>
      <el-card style="border-radius: 0.25rem">
        <div class="flex-items">
          <div class="tui-detailImg">
            <el-image
              :src="detailItem.Img"
              style="width: 4.7125rem; height: 3.0125rem"
              fit="contain"
            >
              <div slot="error" class="image-slot">
                <img
                  style="width: 100%; height: 100%"
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-18/20220818160410_7541.png"
                  alt=""
                />
              </div>
            </el-image>
            <!-- <img :src="detailItem.Img" alt="" /> -->
          </div>
          <div style="width: 100%; padding-left: 0.25rem">
            <div class="flex-between">
              <div class="tui-detailRightTile">{{ detailItem.Name }}</div>
              <div class="flex-items">
                <div
                  class="flex-around"
                  v-if="!userInfo.UserIdentity.includes('1')"
                >
                  <div
                    class="flex-items"
                    style="padding-right: 0.25rem; cursor: pointer"
                    @click="AddSourceFavorite"
                  >
                    <img
                      :src="
                        detailItem.IsFavorite == 0
                          ? 'http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-11/20220811160205_9625.png'
                          : 'http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-8/20220808153430_4372.png'
                      "
                      style="width: 0.5rem; height: 0.5rem"
                      alt=""
                    />
                    <div class="flex tui-like">
                      <div>想去</div>
                      <div style="color: #2396f7">
                        {{ detailItem.FavoriteNum }}
                      </div>
                    </div>
                  </div>
                  <div class="tui-border"></div>
                  <div
                    class="flex-items"
                    style="padding-left: 0.25rem; cursor: pointer"
                  >
                    <img
                      :src="
                        detailItem.IsMake == 0
                          ? 'http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-8/20220808153854_3481.png'
                          : 'http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-11/20220811160302_8000.png'
                      "
                      style="width: 0.5rem; height: 0.5rem"
                      alt=""
                    />
                    <div class="flex tui-like">
                      <div>去过</div>
                      <div style="color: #2396f7">{{ detailItem.MakeNum }}</div>
                    </div>
                  </div>
                </div>
                <div
                  style="padding-left: 30px"
                  v-if="
                    userInfo.UserIdentity.includes('1') ||
                    userInfo.UserIdentity.includes('2')
                  "
                >
                  <el-button type="primary" round @click="onClickDetail"
                    >想去列表</el-button
                  >
                </div>
              </div>
            </div>
            <!-- 标签 -->
            <div
              class="flex-items"
              style="padding: 0.1875rem 0"
              v-if="detailItem.Tag != ''"
            >
              <div
                class="tui-buttonBride"
                v-for="(item, index) in getJsonTag(detailItem.Tag)"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <!-- 信息 -->
            <div class="flex tui-infoDetail">
              地址：<span>{{ detailItem.Address }}</span>
            </div>
            <div class="flex tui-infoDetail">
              电话：<span>{{ detailItem.Tel }}</span>
            </div>
            <div class="flex tui-infoDetail">
              <div class="flex" style="flex-shrink: 0">营业时间：</div>
              <span>{{ detailItem.BusinessHours }}</span>
            </div>
            <div class="flex tui-infoDetail">
              公交信息：<span>{{ detailItem.Transit }}</span>
            </div>
          </div>
        </div>
        <!-- 场馆介绍 -->
        <div class="tui-introduce">
          <div class="tui-introduceTitle">场馆介绍</div>
          <div class="tui-hint" v-if="detailItem.Explain != ''">
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-8/20220808160913_7543.png"
              alt=""
            />
            <div style="padding-left: 0.125rem">
              {{ detailItem.Explain }}
            </div>
          </div>
          <div class="tui-introduceDesc">
            {{ detailItem.Detail }}
          </div>
        </div>
        <!-- 场馆图片 -->
        <div class="tui-stadium" v-if="detailItem.ImgList != ''">
          <div class="tui-stadiumTitle">场馆图片</div>
          <div class="flex-items" style="flex-wrap: wrap">
            <el-image
              class="tui-Image"
              v-for="item in getJsontData(detailItem.ImgList)"
              :key="item"
              :src="item"
              fit="contain"
            >
              <div slot="error" class="image-slot">
                <img
                  style="width: 100%; height: 100%"
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-18/20220818160410_7541.png"
                  alt=""
                />
              </div>
            </el-image>
          </div>
        </div>
      </el-card>
    </div>
    <el-dialog title="详情" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="StudentName" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="ClassName" label="班级名称" align="center">
          </el-table-column>
          <el-table-column
            prop="CreateTime"
            label="时间"
            width="200"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerTitle from "@/components/headerTitle/headerTitle.vue";
import {
  GetSourceDetail,
  AddSourceFavorite,
  GetFavoriteBySource,
} from "../../api/api";

export default {
  components: {
    headerTitle,
  },
  data() {
    return {
      detailItem: {},
      dialogVisible: false,
      userInfo: {},
      tableData: [],
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));

    this.GetSourceDetail();
    //console.log(window.history);
    if (window.history.length <= 1) {
      if (location.href.indexOf("?") === -1) {
        window.location.href = location.href + "?goindex=true";
      } else if (
        location.href.indexOf("?") !== -1 &&
        location.href.indexOf("goindex") === -1
      ) {
        window.location.href = location.href + "&goindex=true";
      }
    }
  },
  methods: {
    // 查看详情
    onClickDetail() {
      this.GetFavoriteBySource();
      this.dialogVisible = true;
    },
    async GetFavoriteBySource() {
      let res = await GetFavoriteBySource({
        Id: this.$route.query.SourceId,
        PageIndex: 1,
        PageSize: 1000000000,
        Name: "",
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
      } else {
        this.tableData = [];
      }
    },
    async AddSourceFavorite() {
      let res = await AddSourceFavorite({
        sourceId: this.$route.query.SourceId,
        classId: this.$route.query.ClassId,
      });
      if (res.data.success) {
        this.GetSourceDetail();
      }
    },
    getJsontData(val) {
      //console.log(val);
      if (val) {
        return val.split(",");
      }
    },
    getJsonTag(val) {
      if (val) {
        let result = val.split("|");
        return result;
      }
    },
    async GetSourceDetail() {
      let res = await GetSourceDetail({
        id: this.$route.query.SourceId,
        classId: this.$route.query.ClassId,
      });
      if (res.data.success) {
        this.detailItem = res.data.response;
      }
    },
  },
};
</script>
<style lang="less">
.tui-stadium {
  width: 100%;
  .tui-stadiumTitle {
    font-size: 0.25rem;
    color: #333;
    font-weight: 600;
    padding: 0.25rem 0;
  }
}
.tui-Image {
  width: calc(100% / 6 - 0.25rem);
  height: 1.9625rem;
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;
  // border-radius: 20px;
  // background: #eee;
}
.tui-Image:nth-of-type(6n) {
  margin: 0;
}
.tui-introduce {
  width: 100%;
  .tui-introduceTitle {
    font-size: 0.25rem;
    color: #333;
    font-weight: 600;
    padding: 0.375rem 0 0.1625rem 0;
  }
  .tui-introduceDesc {
    font-size: 0.225rem;
    color: #333;
    line-height: 0.425rem;
    font-weight: 600;
    padding-top: 0.1875rem;
  }
  .tui-hint {
    display: flex;
    align-items: center;
    width: 100%;
    height: 0.5rem;
    background: #ecf6fe;
    padding: 0 0.25rem;
    box-sizing: border-box;
    color: #2396f7;
    font-size: 0.2rem;
  }
}
.tui-infoDetail {
  font-size: 0.225rem;
  color: #333;
  font-weight: 600;
  padding-bottom: 0.125rem;
  //   padding: 0.125rem 0 0 0;
  //   height: 0.5625rem;
  span {
    color: #666;
    font-size: 0.225rem;
    font-weight: 500;
  }
}

.tui-detailImg {
  width: 4.7125rem;
  height: 3.0125rem;
  border-radius: 0.25rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.tui-like {
  font-size: 0.2rem;
  color: #333;
  padding-left: 0.0625rem;
  flex-direction: column;
  text-align: center;
  cursor: pointer;
}
.tui-border {
  width: 0.0125rem;
  height: 0.5rem;
  background: #cccccc;
}
.tui-detailRightTile {
  font-size: 0.25rem;
  color: #333;
  font-weight: 600;
}
.tui-buttonBride {
  padding: 0 0.125rem;
  height: 0.3rem;
  line-height: 0.3rem;
  background: rgba(35, 150, 247, 0.1);
  border-radius: 0.15rem;
  border: 1px solid #2396f7;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2396f7;
  margin-right: 0.125rem;
}
</style>